{
  "addButtonLabel": "Add procedure or surgery",
  "date": "Date",
  "datePlaceholder": "e.g. June 2022, 2021, or ~5 years ago",
  "location": "Location",
  "locationPlaceholder": "e.g. Ormiston Hospital, Auckland",
  "nextLabel": "$t(common:next): <b>Mobility</b>",
  "procedure": "Procedure or Surgery description",
  "procedurePlaceholder": "e.g. Colonoscopy to investigate bleeding",
  "saveButton": "Save procedure or surgery",
  "text": "<p>We have a record of your previous endoscopy at {{company}}:</p><ul><li><strong>{{procedure}}</strong> in <strong>{{date}}</strong></li></ul><p>Have you had any other endoscopies, abdominal or major surgeries since then?</p>",
  "textNoProcedure": "Have you had any endoscopies, abdominal, or major surgeries in the past?",
  "title": "Recent procedures or surgeries"
}
